import * as React from "react";
import './FormCancellationSteps.css';
import FormButton from "../../../../../components/FormButton/FormButton";
import FormStepper from "../../../components/FormStepper/FormStepper";
import {formStores} from "../../../state/mobx";
import {CancelStates} from "../../../state/CancelStates";
import {InputTypes} from "../../../components/FormStepper/InputTypes";
import {observer} from "mobx-react";
import Icon from "../../../../../components/Icon/Icon";
import {Redirect, RouteComponentProps} from "react-router";
import FormFinish from "../../SignUpForm/FormFinish/FormFinish";
import {isMobile} from "react-device-detect";
import {AnalyticsAccountEvents} from "../../../../../services/Analytics/AnalyticsAccountEvents";
import NavigationConstants from "../../../../Navigation/NavigationConstants";
import {MyAccountStores} from "../../../../MyAccount/state/mobx";
import MixPanelAnalyticsService from "../../../../../services/Analytics/MixPanelAnalyticsService";

interface IProps extends RouteComponentProps<any> {
    closeWindowNavigationPath : string;
}

interface ILocalState {
    navigate: boolean
}
const STORE = formStores.cancelStore;
const accountStore = MyAccountStores.accountUserStore;
const storePropertyName = 'cancellation';
const CANCEL_OPTIONS = ['Leaving this workspace', "Already left this workspace", "Staying in workspace, cancelling Salaryo", "Other"]
@observer
export default class FormCancellationSteps  extends React.Component<
    IProps,
    ILocalState
    > {

    public state: ILocalState = {
        navigate: false
    };

    private options: object[] = [];
    
    constructor (props: IProps) {
        super(props);
        if(!accountStore.selectedPlan) {
            props.history.replace(NavigationConstants.myAccount)
        }
        if(!STORE.formInput[storePropertyName]) {
            STORE.formInput[storePropertyName] = {};
        }
        this.options = CANCEL_OPTIONS.map(item => {
            return {label: item, value: item}
         })
    }

    public updateSelectedDate = (date: Date) => {
        STORE.formInput[storePropertyName].cancellationDate = date.getTime();
    };

    public departureSelected = (val: string) => {
        STORE.formInput.cancellation.reason = val;
        STORE.updateFinishForm(true);
    };

    public renderSteps = () => {
        const cancelSteps: any = [
            {
                isHeader: true,
                title: "Cancel plan",
                inputType: InputTypes.none
            },
            {
                title: "Select your departure date",
                inputType: InputTypes.calendar,
                cb: this.updateSelectedDate,
                propName: "cancellationDate"
            },
            {
                title: "Departure type",
                inputType: InputTypes.dropdown,
                options: this.options,
                cb: this.departureSelected,
                propName: "reason"
            }
        ];
        switch (STORE.currentScreen) {
            case CancelStates.welcome: {
                return (
                    <FormStepper steps={cancelSteps} store={STORE} navigationProperty={storePropertyName}/>
                );
            }
            case CancelStates.finish: {
                return (<FormFinish {...this.props} isCancel={true}/>)
            }

            default: return null
        }
    };

    public cancelPlan = () => {
        MixPanelAnalyticsService.track(AnalyticsAccountEvents.cancelPlanSubmit);
        STORE.cancelPlan()
    };


    public renderNavigation = () => {
        if (STORE.currentScreen === CancelStates.welcome) {
            const btnClasses = STORE.allowFinishForm? 'yellow' : 'disabled';
            return (<div className="cancellation-navigation">
                <FormButton btnText={"Cancel plan"} classes={btnClasses} click={this.cancelPlan}/>
            </div>);
        }
        return null;
    };

    public closeCancellation = () => {
        STORE.updateScreen(CancelStates.welcome);
        const newState = this.state;
        newState.navigate = true;
        this.setState(newState);
    };

    public renderClose = () => {
        const classes = isMobile? "close-btn-navigation mobile" : "close-btn-navigation";
        return (<div className={classes} onClick={this.closeCancellation}>
            <Icon icon={"exitBtn"}/>
        </div>);
    }

    public render() {
        const { navigate } = this.state;
        const { closeWindowNavigationPath } = this.props;
        if (navigate) {
            return <Redirect to={closeWindowNavigationPath} />;
        }
        return (
            <>
                <div className="cancellation-container">
                    {this.renderClose()}
                    {this.renderSteps()}
                </div>
                {this.renderNavigation()}
            </>
        )
    }
}




// WEBPACK FOOTER //
// ./src/scenes/Forms/screens/FormCancel/FormCancellationSteps/FormCancellationSteps.tsx